import React, { useState } from 'react'
import styles from './MicrositeSortableSocialList.module.css'
import { GripVertical, Trash2, Instagram, Facebook, Twitter, Youtube, Linkedin, MessageCircle, Link2 } from 'lucide-react'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'

const PLATFORM_ICONS = {
    instagram: Instagram,
    facebook: Facebook,
    twitter: Twitter,
    youtube: Youtube,
    linkedin: Linkedin,
    whatsapp: MessageCircle
}

/**
 * MicrositeSortableSocialList
 * Drag-to-reorder list of social platform links with icon,
 * URL input, and visibility toggle.
 *
 * Usage:
 *   <MicrositeSortableSocialList
 *     links={form.social}
 *     onChange={(next) => updateField('social', next)}
 *   />
 */
const MicrositeSortableSocialList = ({ links = [], onChange }) => {
    const [dragIdx, setDragIdx] = useState(null)

    const updateLink = (idx, field, value) => {
        const next = links.map((l, i) => (i === idx ? { ...l, [field]: value } : l))
        onChange?.(next)
    }

    const removeLink = (idx) => {
        onChange?.(links.filter((_, i) => i !== idx))
    }

    const handleDrop = (idx) => {
        if (dragIdx === null || dragIdx === idx) {
            setDragIdx(null)
            return
        }
        const next = [...links]
        const [moved] = next.splice(dragIdx, 1)
        next.splice(idx, 0, moved)
        onChange?.(next.map((l, i) => ({ ...l, sortOrder: i })))
        setDragIdx(null)
    }

    return (
        <div className={styles.list}>
            {links.map((link, idx) => {
                const Icon = PLATFORM_ICONS[link.platform] || Link2
                return (
                    <div
                        key={idx}
                        className={`${styles.row} ${dragIdx === idx ? styles.rowDragging : ''}`}
                        draggable
                        onDragStart={() => setDragIdx(idx)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(idx)}
                    >
                        <GripVertical size={14} className={styles.dragHandle} />
                        <div className={styles.platformIconWrap}>
                            <Icon size={14} />
                        </div>
                        <span className={styles.platformLabel}>{link.platform}</span>
                        <input
                            type="text"
                            className={styles.urlInput}
                            value={link.url}
                            onChange={(e) => updateLink(idx, 'url', e.target.value)}
                            placeholder={`https://${link.platform}.com/yoursalon`}
                        />
                        <ToggleSwitch
                            size="sm"
                            checked={!!link.isVisible}
                            onChange={(v) => updateLink(idx, 'isVisible', v)}
                        />
                        <button type="button" className={styles.removeBtn} onClick={() => removeLink(idx)}>
                            <Trash2 size={13} />
                        </button>
                    </div>
                )
            })}
        </div>
    )
}

export default MicrositeSortableSocialList